import { ROUTES } from '@shared/config/routes';
import type { NotificationType, NotificationView } from '../model/types';

const HANDLERS: Partial<Record<NotificationType, (payload: Record<string, unknown>) => string | null>> = {
  RFQ_RECEIVED: (p) => (typeof p.buyRequestId === 'string' ? `/buy-requests/${p.buyRequestId}/respond` : ROUTES.buyRequests),
  QUOTE_ACCEPTED: (p) => (typeof p.orderId === 'string' ? ROUTES.orderDetail(p.orderId) : ROUTES.quotes),
  ORDER_STATUS_CHANGED: (p) => (typeof p.orderId === 'string' ? ROUTES.orderDetail(p.orderId) : ROUTES.orders),
  CHAT_MESSAGE: (p) =>
    typeof p.conversationId === 'string' ? ROUTES.chatDetail(p.conversationId) : ROUTES.chats,
  KYC_APPROVED: () => ROUTES.profile,
  KYC_REJECTED: () => ROUTES.profile,
};

export function notificationDeepLink(n: NotificationView): string | null {
  const handler = HANDLERS[n.type];
  if (!handler) return null;
  return handler(n.payload ?? {});
}

export function deepLinkForType(
  type: NotificationType,
  payload: Record<string, unknown> | null,
): string | null {
  const handler = HANDLERS[type];
  return handler ? handler(payload ?? {}) : null;
}

export function parsePushPayload(payloadJson: string | null | undefined): Record<string, unknown> {
  if (!payloadJson) return {};
  try {
    const parsed = JSON.parse(payloadJson) as unknown;
    return parsed && typeof parsed === 'object' ? (parsed as Record<string, unknown>) : {};
  } catch {
    return {};
  }
}
